// ----------------------------------------------------------------------

const shape = {
  borderRadius: 4,
  borderRadiusSm: 4,
  borderRadiusMd: 4
};

export default shape;
